import { Injectable } from '@angular/core';
import { LayerThematicStylesDto } from '@cloud-twin-v2/generated/simulation.generated.client';
import { BaseService } from '@common-modules/shared/base.service';
import { Observable, ReplaySubject, switchMap, take } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CtMapThematicsService extends BaseService {
  private readonly _workspaceId$ = new ReplaySubject(null);

  private get entityUrl(): string {
    return `${this.apiUrl}/map/styles/thematics`;
  }

  setCurrentWorkspace(workspaceId: string): void {
    this._workspaceId$.next(workspaceId);
  }

  getCurrentThematics(): Observable<LayerThematicStylesDto[]> {
    return this._workspaceId$.pipe(
      take(1),
      switchMap((workspaceId) => {
        return this.httpCacheClient.get<LayerThematicStylesDto[]>(
          `${this.entityUrl}?workspaceId=${workspaceId}`,
        );
      }),
    );
  }
}
